import { IS_LOCAL_MODE } from './environments';

import type EnvVariablesClass from './env';
import type { Options } from 'http-proxy-middleware';

/**
 * Настройка прокси для local
 */

interface ProxyOptionsObject {
  [target: string]: Options;
}

export function addHttps (url: string) {
  return url.startsWith('https://') ? url : `https://${ url }`;
}

export function createProxyUrl (base: string, prefix?: string) {
  const url = new URL(addHttps(base));
  if (prefix) {
    url.host = `${ prefix }.${ url.host }`;
  }
  return url.toString();
}

export default (env: EnvVariablesClass): ProxyOptionsObject => {
  if (!IS_LOCAL_MODE) {
    return {};
  }

  const base = env.MAIN_SITE_HOST || 'staging.strana.itstrana.site';

  return {
    '/api/services': {
      target: createProxyUrl(base, 'services'),
      pathRewrite: {
        '^/api/services': '/api',
      },
    },
    '/loyalty/api/v1/': {
      target: createProxyUrl(base, 'services'),
      pathRewrite: {
        '^/loyalty/api/v1/': '/loyalty/api/v1/',
      },
    },

    '/api': {
      target: createProxyUrl(base, 'lk'),
    },
    '/graphql': {
      target: createProxyUrl(base),
    },
  };
};
